import axios from "axios";
import SummaryAPI from "../common/SummaryAPI";

const instance = axios.create({
  baseURL: process.env.REACT_APP_URL,
  withCredentials: true
});



export default instance;